/* import __COLOCATED_TEMPLATE__ from './bandpass-multiplefeedback-posfb.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();